import React,{useEffect} from 'react'
import { RotatingSquare } from 'react-loader-spinner'

export default function UploadProgress({progressCount}) {
    
    return (
        <>
            <RotatingSquare
                height="20"
                width="50"
                color="#1d649b"
                ariaLabel="rotating-square-loading"
                strokeWidth="4"
                className="file_uploaded"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
            />
            {/* {progressCount} */}
        
        </>
    )
}
